import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { AUDIO_TYPE } from "../types.js";
import AudioViewer from "./audio-viewer.js";
const Audio = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(AudioViewer, { node, settings: config[AUDIO_TYPE] }));
};
var audio_default = Audio;
export {
  audio_default as default
};
//# sourceMappingURL=audio.js.map
